(async function () {
  function norm(s) {
    return (s || "").toString().trim().toLowerCase().replace(/\s+/g, " ");
  }

  function getHandle() {
    const part = location.pathname.split("/products/")[1];
    return part ? part.split("/")[0] : null;
  }

  function getUrlVariant() {
    return new URL(location.href).searchParams.get("variant");
  }

  function setUrlVariant(id) {
    const u = new URL(location.href);
    u.searchParams.set("variant", id);
    history.replaceState({}, "", u.toString());
  }

  async function loadProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) return null;
    return await res.json();
  }

  const handle = getHandle();
  if (!handle) return;

  const product = await loadProduct(handle);
  if (!product || !Array.isArray(product.variants)) return;

  // Find selects by label text
  function findSelectByLabelText(labelText) {
    const els = [...document.querySelectorAll("label, .m-product-option, .product-form__input")];
    const t = els.find(el => norm(el.textContent).includes(norm(labelText)));
    if (!t) return null;
    return t.querySelector("select") || t.closest("div")?.querySelector("select") || t.parentElement?.querySelector("select");
  }

  function getOptionTexts() {
    const modelSel = findSelectByLabelText("compatible model");
    const colorSel = findSelectByLabelText("colour") || findSelectByLabelText("color");

    let s1 = modelSel, s2 = colorSel;

    // fallback: first two visible selects
    if (!s1 || !s2) {
      const visibles = [...document.querySelectorAll("select")].filter(s => s.offsetParent !== null);
      s1 = s1 || visibles[0];
      s2 = s2 || visibles[1];
    }

    if (!s1 || !s2) return null;

    const o1 = s1.options[s1.selectedIndex]?.textContent;
    const o2 = s2.options[s2.selectedIndex]?.textContent;
    return { opt1: o1, opt2: o2 };
  }

  function findVariantId(opt1, opt2) {
    const n1 = norm(opt1), n2 = norm(opt2);

    let v = product.variants.find(x => norm(x.option1) === n1 && norm(x.option2) === n2);
    if (v) return String(v.id);

    v = product.variants.find(x => norm(x.option1) === n2 && norm(x.option2) === n1);
    if (v) return String(v.id);

    return null;
  }

  function setVariantIdInForms(variantId) {
    document.querySelectorAll('form[action^="/cart/add"] input[name="id"]').forEach(inp => {
      inp.value = variantId;
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  // ✅ loop guard using sessionStorage
  const GUARD_KEY = "cfc_variant_reload_guard";
  const lastReloadedVariant = sessionStorage.getItem(GUARD_KEY);

  let lastSynced = null;

  function updateGalleryByVariant(variantId) {
  const gallery = document.querySelector("media-gallery");
  if (!gallery) return;

  // Minimog listens to this event
  gallery.dispatchEvent(
    new CustomEvent("variant:changed", {
      bubbles: true,
      detail: { variant: { id: Number(variantId) } }
    })
  );
}


  function sync(allowReload) {
    const sel = getOptionTexts();
    if (!sel) return;

    const vid = findVariantId(sel.opt1, sel.opt2);
    if (!vid) return;

    // If already synced, do nothing
    if (vid === lastSynced) return;
    lastSynced = vid;

    setVariantIdInForms(vid);
    setUrlVariant(vid);
    updateGalleryByVariant(vid);


    // ✅ reload only if user changed something AND we are not already on that variant
    const urlVid = getUrlVariant();
    if (
      allowReload &&
      urlVid !== vid &&
      lastReloadedVariant !== vid
    ) {
      sessionStorage.setItem(GUARD_KEY, vid);
      location.replace(`${location.pathname}?variant=${vid}`);
    }
  }

  // Initial sync (NO reload on load)
  setTimeout(() => sync(false), 400);

  // Reload only on real user actions
  document.addEventListener(
    "change",
    () => setTimeout(() => sync(true), 80),
    true
  );

})();
